"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _dispatcher = _interopRequireDefault(require("dispatcher/dispatcher"));

var _ActionNamespaces = require("../actions/ActionNamespaces");

var _ActionTypes = require("../actions/ActionTypes");

var _LazyValueStore = require("../store/LazyValueStore");

var _ActivityTypesAPI = require("./ActivityTypesAPI");

var _default = (0, _LazyValueStore.defineLazyValueStore)({
  fetch: _ActivityTypesAPI.fetch,
  namespace: _ActionNamespaces.ACTIVITY_TYPES
}).defineName('ActivityTypesStore').defineResponseTo(_ActionTypes.ACTIVITY_TYPES_UPDATED, function (state, _ref) {
  var error = _ref.error,
      newActivityTypes = _ref.newActivityTypes;

  if (error) {
    return state;
  }

  return state.set('value', newActivityTypes);
}).register(_dispatcher.default);

exports.default = _default;
module.exports = exports.default;